import React from 'react';
import { Box, Paper, Typography } from '@mui/material';

export default function AccessDeniedState({ title = 'Access Denied', message = 'You do not have permission to view this page.' }) {
  return (
    <Box sx={{ minHeight: '100vh', ml: { md: '240px' }, mt: '64px', p: { xs: 2, md: 4 } }}>
      <Paper sx={{ p: 4, borderRadius: 3, maxWidth: 640 }}>
        <Typography variant="h4" color="text.primary" gutterBottom>
          {title}
        </Typography>
        <Typography color="text.secondary">
          {message}
        </Typography>
      </Paper>
    </Box>
  );
}
